// extracted by mini-css-extract-plugin
export default {"searchInputs":"SearchBar_searchInputs__zjp9z","inputArea":"SearchBar_inputArea__6VNTS","searchIcon":"SearchBar_searchIcon__QhQBu","dataResult":"SearchBar_dataResult__mSHcW"};